import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import MaintenanceTable, { TMaintenanceItem } from "./MaintenanceTable";
import PelletsLevelChart from "./PelletsLevelChart";
import { useUser } from "../../../contexts/UserProvider";
import { IControlBiolyt } from "../types";
import { useTranslation } from "react-i18next";

interface IControlDetailsBiolytProps {
  control: IControlBiolyt;
}

const ControlDetailsBiolyt = (props: IControlDetailsBiolytProps) => {
  const { control } = props;
  const { user } = useUser();
  const { t } = useTranslation();
  const items: TMaintenanceItem[] = [
    { name: t("Clean burner"), attribute: "burner_cleaned_timestamp" },
    { name: t("Empty ashes"), attribute: "ashes_emptied_timestamp" },
  ];
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    >
      <PelletsLevelChart control={control} width={300} height={80} />
      <MaintenanceTable
        control={control}
        items={items}
        reset={user?.is_operator || false}
      />
    </ControlDetailsPanel>
  );
};

export default ControlDetailsBiolyt;
